// material-ui
import { Box, Divider, Typography } from "@mui/material";
import { Fragment } from "react";

// project import
import useAuth from "@/hooks/useAuth";
import { MenuItems } from "@/types/menu";

// project import
import NavGroup from "./NavGroup";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

interface NavigationProps {
  drawerOpen?: boolean;
  menuItems: MenuItems;
}

const Navigation = ({ drawerOpen, menuItems }: NavigationProps) => {
  const { isAdmin } = useAuth();

  const filteredMenuItems = menuItems.items.filter((item) => {
    if (item.adminOnly) {
      return isAdmin;
    }
    return true;
  });

  const visibleMenuItems = filteredMenuItems.map((item) => ({
    ...item,
    children: item.children?.filter((child) => !child.adminOnly || isAdmin),
  }));

  const navGroups = visibleMenuItems.map((item, i) => {
    switch (item.type) {
      case "group":
        return (
          <Fragment key={item.id}>
            {drawerOpen && item.title && (
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "12px",
                  lineHeight: "22px",
                  textTransform: "uppercase",
                  px: 2.5,
                  py: "6px",
                  color: "text.secondary",
                }}
              >
                {item.title}
              </Typography>
            )}
            <NavGroup item={item} />
            {i < filteredMenuItems.length - 1 && (
              <Divider
                role="separator"
                sx={{
                  px: "6px",
                  borderColor: "#D8D8D8",
                  mt: drawerOpen ? "24px" : "2px",
                  mb: drawerOpen ? "24px" : "8px",
                }}
              />
            )}
          </Fragment>
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box role="navigation">{navGroups}</Box>;
};

export default Navigation;
